export default function getResumeNumber(answersByItem, destructuredSubtest) {
  let output = 1
  let once = false
  destructuredSubtest.items.forEach((item, n) => {
    if (!once && !answersByItem[item]) {
      output = n + 1
      once = true
    }
  })
  return output
}


// WEBPACK FOOTER //
// ./src/helpers/assessment/getResumeNumber.js